<template>
  <div class="main-template">
    <v-snackbar
      v-if="successMessage"
      v-model="successMessage"
      :timeout="5000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-if="errorMessage"
      v-model="successMessage"
      :timeout="5000"
      color="danger"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="errorMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <d-table
      tableName="packages"
      sortBy="order"
      :data_object="data_object"
      :getFreshData="true"
      :filterTabs="filterTabs"
      addButtonCaption="Add Customer"
      :linkClick="linkClick"
      :link="link"
      :editRow="true"
      :alwaysUpdate="true"
      itemsPerPage="50"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      :onDataReceived="onDataReceived"
      :getRowClass="getRowClass"
    />
    <!-- <div v-if="documentBody" v-html="documentBody"></div> -->
    <v-dialog v-model="dialog" max-width="80%" class="pa-2">
      <div class="ma-2 pa-2">
        <v-document
          ref="doc"
          v-if="letterReady"
          v-bind="letterBind"
          :key="docKey"
        ></v-document>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "MoveraiPackage",
  components: { DTable, VDocument: () => import("../components/Document.vue") },
  props: {},
  data() {
    return {
      letterBind: null,
      letterReady: false,
      dialog: false,
      docKey: 0,
      documentBody: "",
      filterTabs: [],
      data_object: {
        object_name: "my_customers",

        // mobileBreakpoint: 0,
        all_records: true,

        hasSearch: true,
      },
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      successMessage: "",
      errorMessage: "",
      tableKey: 0,
    };
  },
  mounted() {
    var that = this;
    var tabs = ["monthly", "quarterly", "semiannually", "annually"];
    tabs.forEach((t) => {
      this.filterTabs.push({
        caption: fun.capitalize(t),
        name: "frequency",
        value: t,
      });
    });
    this.$root.$on("firstDataCardCharges", (d) => {
      console.log(d);
      that.updatePayment(d);
    });
    this.$root.$on("customBtnClick", (d) => {
      console.log(d);
    });
    //customBtnClick
    //    this.updateNextPaymentDate();
    //tableMounted
    // this.$root.$on("tableMounted", obj => {
    //   if (obj.tableName == "packages") {
    //     that.updateNextPaymentDate(obj.table);
    //   }
    // });
    this.$root.$on("customBtnClick", (obj) => {
      if (obj.btn == "view_invoice") {
        console.log(obj.frm.model);
        var model = that.$refs.dTable.editedItem;
        model.current_invoice = obj.frm.model;
        that.showDocument(model, "invoice");
      }
      if (obj.btn == "charge_my_customers") {
        console.log(obj);
        var accounts = obj.tbl.table.filter((t) => {
          return t.due_now;
        });
        var customers = accounts.map((account) => account.company);

        this.$root.$confirm
          .open(
            "Charging Customer",
            "Confirm charging " + customers.join(", ") + "?",
            {
              color: "red",
            }
          )
          .then((confirm) => {
            if (confirm) {
              console.log("charging");

              axios
                .post(this.serverURL + "/process_recurring_payments")
                .then((response) => {
                  console.log(response);
                  this.successMessage =
                    "Charges Processed for " + response.data;
                });
              this.$refs.dTable.refreshTable();

              //     this.successMessage = "successfully removed " + item.value;
              //     delete this.additionalTabs[item.value];
              //     this.filterItems = this.filterItems.filter(
              //       obj => obj.value !== item.value
              //     );
              //     this.updateAdditionalTabs();

              //     console.log(this.filteredTabItems);
              //     // this.tabKey = !this.tabKey;
              //   });
            }
          });

        //
        // const todayStr = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

        // accounts = accounts.filter(account => {
        //   if (account.portal_id == 199) {
        //     console.log(account);
        //   }
        //   const nextPaymentDate = this.calculateNextPaymentDate(account);

        //   return (
        //     nextPaymentDate &&
        //     nextPaymentDate.toISOString().split("T")[0] === todayStr
        //   );
        // });
        // console.log(accounts);
      }
    });
  },
  beforeDestroy() {},

  methods: {
    showDocument(model, documentName) {
      var data = {
        object_name: "document",
        qry: { document_name: documentName },
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.model[0]) {
            this.documentBody = response.data.model[0].body;
            this.letterBind = {
              email: model.contact.email,
              // documentId: obj.value,
              model: model,
              // shipmentModel: shipmentModel,
              documentModel: response.data.model[0],
              bodyTemplate: "<div>" + this.documentBody + "</div>",
              introBodyTemplate:
                "<div>" + response.data.model[0].intro_body + "</div>",
            };
            this.dialog = true;
            this.letterReady = true;
          } else {
            this.errorMessage = "Document not found";
          }

          // this.successMessage = response.data;
        });
    },
    onDataReceived(data) {
      data.model.forEach((account) => {
        // if (account.portal_id == 118) {
        //   console.log(account);
        // }
        if (account.frequency) {
          const nextPaymentDate = this.calculateNextPaymentDate(account);
          account.due_now = "";
          if (nextPaymentDate <= new Date()) {
            account.due_now = "due now";
          }
          // if (!account.next_payment_day) {
          account.next_payment_day = fun.formatDate(
            nextPaymentDate,
            false,
            false,
            true
          );
          // }
        }
      });
      return data;
    },
    getRowClass(r) {
      if (r.due_now) {
        return "red";
      }
    },
    calculateNextPaymentDate(account) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Ensure only date is compared
      // if (account.portal_id == 219) {
      //   console.log(account);
      // }
      let nextPayment = account.last_payment_day
        ? new Date(account.last_payment_day)
        : new Date(account.first_payment_day);

      nextPayment.setHours(0, 0, 0, 0); // Remove time for comparison

      // Calculate next payment date until it is in the future
      // Step 1: Ensure next payment is in the **current** year
      if (
        nextPayment.getFullYear() < today.getFullYear() &&
        today - nextPayment > 365 * 24 * 60 * 60 * 1000
      ) {
        nextPayment.setFullYear(today.getFullYear());
      }

      // Step 2: If next payment has **already passed this year**, move it forward by 1 cycle
      if (nextPayment <= today) {
        switch (account.frequency) {
          case "monthly":
            nextPayment.setMonth(nextPayment.getMonth() + 1);
            break;
          case "quarterly":
            nextPayment.setMonth(nextPayment.getMonth() + 3);
            break;
          case "semiannually":
            nextPayment.setMonth(nextPayment.getMonth() + 6);
            break;
          case "annually":
            nextPayment.setFullYear(nextPayment.getFullYear() + 1);
            break;
          default:
            return null; // Invalid frequency
        }
      }
      return nextPayment;
    },

    updatePayment(d) {
      // this.tableKey = !this.tableKey;
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
    afterSave(tbl, model) {
      console.log(model);
      this.tableKey = !this.tableKey;
      // this.$forceUpdate();
      // location.reload();
      // axios
      //   .post(this.serverURL + "/sync_products", {
      //     package: model,
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     this.successMessage = response.data;
      //   });
      //sync_products
    },
  },
};
</script>

<style lang="css" scoped></style>
